import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { terminologyMap } from "../Helpers/terminologyMapping";
import { useUser } from "../Query/useUsers";

export const useTerminology = () => {
  const { data: userData } = useUser();
  const [terminology, setTerminology] = useState({
    singular: "Entity",
    plural: "Entities",
    genitive: "Entity",
  });

  const { i18n } = useTranslation();
  const lang = i18n.language.startsWith("de") ? "de" : "en";

  useEffect(() => {
    if (userData?.workspace?.terminology !== undefined) {
      const selected = terminologyMap[userData.workspace.terminology]?.[lang];

      setTerminology({
        singular: selected?.singular ?? "Entity",
        plural: selected?.plural ?? "Entities",
        genitive:
          lang === "de"
            ? (selected?.genitive ?? selected?.singular)
            : selected?.singular,
      });
    }
  }, [userData, lang]);

  return terminology;
};
